module.exports = __webpack_public_path__ + "img/9788970636160.96b5de9e.jpg";